import { useState, useEffect, useRef, useCallback } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../../Lib/contextLib';
import { getVideo, GetUserVideo } from '../../s3Func/s3Download';
import { API, Auth } from 'aws-amplify';
import PopUp from '../../Popup/logoutPopup';
import { CloudfrontVideoFormat } from '../../videos/CloudfrontVideoFormat';
import './Module12World.css';
import Draggable from 'react-draggable';

import Learn from '../../Learn/Learn';
import Practice from './Practice';
import SingingTime from '../../SingingTime/SingingTime';
import FollowTheBeatModule7 from '../../FollowTheBeat/FollowTheBeatModule7';
import Celebrate from '../../Celebrate/Celebrate';
import Surprise from '../../SurpriseVideo/surprise';
import presentSound from './../../Unit1/Module1/assets/ta_da_gift.mp3';
import loading from './../../loading-gif-png-5.gif';

const Module12World = () => {
  const [clientHeight, setVh] = useState(window.innerHeight);
  const [clientWidth, setVw] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setVh(window.innerHeight);
      setVw(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [clientHeight, clientWidth]);

  const { userHasAuthenticated } = useAppContext();
  const dispatch = useDispatch();
  const { module12 } = useSelector((state) => state.module12, shallowEqual);
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

  const background = generateImageUrl('images/Module12Images/Unit3_Mod2BG.png');
  const background2 = generateImageUrl('images/Module2Images/U1M2_DayScene_Landscape.png');
  const animal = generateImageUrl('images/Module2Images/Dog.png');
  const dog = generateImageUrl('images/Module2Images/Dog+Still.gif');
  const progressbar0 = generateImageUrl('images/Module2Images/EmptyBone.png');
  const progressbar1 = generateImageUrl('images/Module2Images/Bone1outof3.png');
  const progressbar2 = generateImageUrl('images/Module2Images/Bone1outof3.png');
  const progressbar3 = generateImageUrl('images/Module2Images/Bone2outof3.png');
  const progressbarCompleted = generateImageUrl('images/Module2Images/Bone3outof3.png');
  const coin = generateImageUrl('images/Images/AwesomeCoin.png');
  const coinBar = generateImageUrl('images/Images/Coin+Counter.png');
  const journeyImage = generateImageUrl('images/Module1Images/bluejourneymap.svg');
  const logoutBtn = generateImageUrl('images/Module1Images/Logout.png');
  const reviewBtn = generateImageUrl('images/Module1Images/Button_Review.png');
  const rewardBtn = generateImageUrl('images/Module1Images/Button_Reward_3x.png')
  const celebrateBtn = generateImageUrl('images/Module1Images/Button_Celebrate.png');
  const learnBtn = generateImageUrl('images/Module1Images/Button_Learn.png');
  const practiceBtn = generateImageUrl('images/Module1Images/Button_Practice.png');
  const ftbBtn = generateImageUrl('images/Images/Button_FTB.png');
  const keyReward = generateImageUrl('images/Module2Images/Bone3outof3.png');
  const dirtCloud = generateImageUrl('images/Module2Images/Dirt+cloud.png');
  const SlideRed = generateImageUrl('images/Module2Images/Reward_RedSlide.png');
  const SlideYellow = generateImageUrl('images/Module2Images/Reward_YellowSlide.png');
  const GnomeBlue = generateImageUrl('images/Module7Images/DailyReward_Gnome1.png');
  const GnomeGreen = generateImageUrl('images/Module7Images/DailyReward_Gnome2.png');
  const TireSwing = generateImageUrl('images/Module2Images/Reward_TireSwing.png');
  const SpringToy = generateImageUrl('images/Module2Images/Reward_BikeSpringChair.png');
  const FairyGreen = generateImageUrl('images/Module7Images/DailyReward_Fairy2.png');
  const FairyPurple = generateImageUrl('images/Module7Images/DailyReward_Fairy1.png');
  const MonkeybarsBlue = generateImageUrl('images/Module2Images/Reward_MonkeyBarsBlue.png');
  const MonkeybarsYellow = generateImageUrl('images/Module2Images/Reward_MonkeyBarYellow.png');
  const FrogCrown = generateImageUrl('images/Module7Images/DailyReward_Frog_Crown2.png');
  const FrogVelvet = generateImageUrl('images/Module7Images/DailyReward_Frog_Crown1.png');
  const KitePink = generateImageUrl('images/Module2Images/Reward_KitePurple.png');
  const KitePurple = generateImageUrl('images/Module2Images/Reward_KitePink.png');
  const FlowerPink = generateImageUrl('images/Module7Images/DailyReward_Flower_Pink.png');
  const FlowerBlue = generateImageUrl('images/Module7Images/DailyReward_Flower_Blue.png');
  const FaeDragon = generateImageUrl('images/Module7Images/BigReward_Fae_Dragon.png');
  const FaeHouse = generateImageUrl('images/Module7Images/BigReward_Fae_House.png');
  const greenCheck = generateImageUrl('images/Module1Images/GreenCheck-Button.png');
  const SingingTimeIcon = generateImageUrl('images/Module1Images/Button_SingingTime.png');
  const AfterCelebrateVideo9 = 'e22793d3d19a423af8143ed9a89c/480.m3u8';
  const present = generateImageUrl('images/Images/Gift.png');

  const [reviewIcon, setReviewIcon] = useState(false);
  const [keyIcon, setKeyIcon] = useState(false);
  const [coinIcon, setCoinIcon] = useState(false);
  const [presentIcon, setPresentIcon] = useState(false);
  const [rewardOption1, setRewardOption1] = useState(null);
  const [rewardOption2, setRewardOption2] = useState(null);
  const [displayReward, setDisplayReward] = useState(false);
  const [playDiggingAudio, setPlayDiggingAudio] = useState(false);

  const [displayLearn, setDisplayLearn] = useState(false);
  const [displayPractice, setDisplayPractice] = useState(false);
  const [displayDay4Practice, setDisplayDay4Practice] = useState(false);
  const [displaySingingTime, setDisplaySingingTime] = useState(false);
  const [displayCelebrate, setDisplayCelebrate] = useState(false);
  const [displaybody, setDisplayBody] = useState(true);
  const [displayGreenButton, setdisplayGreenButton] = useState(false);
  const [learn, setLearn] = useState('');
  const [day4Practice, setDay4Practice] = useState('');
  const [singTime, setSingTime] = useState('');
  const [celebrate, setCelebrate] = useState('');
  const firstUpdate = useRef(true);
  const coinUpdate = useRef(true);
  const [displayIntroVideo, setDisplayIntroVideo] = useState(false);
  const [introVideo, setIntroVideo] = useState('');
  const [displaySurprise, setDisplaySurprise] = useState(false);
  const [surpriseVideo, setSurpriseVideo] = useState('');
  const [displayVoice, setDisplayVoice] = useState(false);
  const [animalVoice, setAnimalVoice] = useState('');
  const [displayFTB, setDisplayFTB] = useState(false);
  const [prize, setPrize] = useState(false);
  const [disPlayPrize, setDisplayPrize] = useState(false);
  const [checkStep, setCheckStep] = useState('');
  const touchSound = new Audio(generateImageUrl('media/Module1Videos/touch_button.mp3'));

  const keys5 = [
    progressbar0,
    progressbar1,
    progressbar2,
    progressbar2,
    progressbar3,
    progressbarCompleted,
  ];
  const keys4 = [
    progressbar0,
    progressbar1,
    progressbar2,
    progressbar3,
    progressbarCompleted,
  ];

  const [touchButton, setTouchButton] = useState(false);
  const [checkSound, setCheckSound] = useState(false);
  const [buttonSound, setButtonSound] = useState(false);
  const [rewardsFound, setRewardsFound] = useState(false);
  const [coinAnimationState, setCoinAnimationState] = useState('bounceIcons');
  const [coinAudio, setCoinAudio] = useState(false);

  const [playDogCelebrate, setPlayDogCelebrate] = useState(false);
  const [rewardAnimationState, setRewardAnimationState] = useState('');
  const [dogState, setDogState] = useState(dog);
  const [dirtState, setDirtState] = useState(false);
  const [playDigging, setPlayDigging] = useState(false);
  const [showReward, setShowReward] = useState(false);

  const [ftbMusic, setFTBMusic] = useState('');
  const [ftbInstruction, setFTBInstruction] = useState('');
  const [ftbInstructionGIF, setFTBInstructionGIF] = useState('');
  const [ftbCount, setFTBCount] = useState('');
  const [ftbTutorial1, setFTBTutorial1] = useState('');
  const [ftbTutorial2, setFTBTutorial2] = useState('');
  const [ftbWT, setFTBWalkThrough] = useState('');

  const [amazingJobDog, setAmazingJobDog] = useState('');
  const [answerSpecialMessage, setAnswerSpecialMessage] = useState('');
  const [answerWatch, setAnswerWatch] = useState('');
  const [practiceIntro, setPracticeIntro] = useState('');
  const [learnIntro, setLearnIntro] = useState('');
  const [celebrateIntro, setCelebrateIntro] = useState('');
  const [followTheBeatIntro, setFollowTheBeatIntro] = useState('');
  const [showAnimal, setShowAnimal] = useState(false);
  const [animalState, setAnimalState] = useState('');
  const [animalClose, setAnimalClose] = useState('');
  const [animalCloseAudio, setAnimalCloseAudio] = useState('');
  const [dogDig, setDogDig] = useState('');
  const [audioReady, setAudioReady] = useState(false);
  const influencers = [
    login.influencerid,
    login.influencerid1,
    login.influencerid2,
    login.influencerid3,
    login.influencerid4,
  ];

  const playButtonAudio = useCallback(() => {
    sleep(700).then(() => {
      setButtonSound(true);
    });
  }, []);

  function getGifs (){
    setAmazingJobDog(getVideo('appfiles/answer/answer_amazing_job.gif', login));

    setDogDig(getVideo('appfiles/listening/dog_dig.gif', login));

    setCelebrateIntro(getVideo('appfiles/answer/answer_celebrate_intro.gif', login));

    setAnimalCloseAudio(getVideo('appfiles/understand_feelings/understand_feelings_day_finished.mp3', login));

    setLearnIntro(getVideo('appfiles/answer/answer_learn_intro.gif', login));

    setPracticeIntro(getVideo('appfiles/answer/answer_practice_intro.gif', login));

    setAnswerSpecialMessage(getVideo('appfiles/answer/answer_practice_special_message.gif', login));

    setAnswerWatch(getVideo('appfiles/answer/answer_practice_watch_conversation.gif', login));

    setFollowTheBeatIntro(getVideo('appfiles/answer/answer_ftb_intro.gif', login));

    setAnimalClose(getVideo('appfiles/answer/answer_day_finished.gif', login));

    setFTBInstruction(getVideo('appfiles/understand_feelings/understand_feelings_ftb_instructions.mp3', login));

    setFTBInstructionGIF(getVideo('appfiles/answer/answer_ftb_instructions.gif', login));

    setFTBMusic(getVideo('appfiles/answer/answer_ftb_audio.m4a', login));

    setFTBCount(getVideo('appfiles/answer/countingDog.gif', login));

    if (!module12.unlockedDays.day2) {
      setFTBTutorial1(getVideo('appfiles/greet/ftb_walkthrough_touch_circle.mp3', login));

      setFTBTutorial2(getVideo('appfiles/understand_feelings/ftb_walkthrough_sway.mp3', login));

      setFTBWalkThrough(getVideo('appfiles/answer/ftb_walkthrough_audio.mp3', login));
    }

  }

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  const coinAnimation = () => {
    setCoinAnimationState('coinAnimation');
    setCoinAudio(true);
  };

  const createGameDetails = useCallback(
    (flag, reward, coin) => {
      const game_detail = module12.game_details;
      if (flag) {
        const flags = { flag, lastUpdated: new Date().toJSON() };
        game_detail.moduleFlags.psuh(flags);
      }
      if (coin >= 0) {
        game_detail.tokens_earned = coin;
      }
      if (reward) {
        const dailyRewards = [];
        for (const key in module12.rewards) {
          if (module12.rewards[key].unlocked === true) {
            const rewards = {
              type: key,
              x_multiplier: module12.rewards[key].x,
              y_multiplier: module12.rewards[key].y,
            };
            dailyRewards.push(rewards);
          }
        }
        game_detail.dailyRewards = dailyRewards;
      }
      dispatch({ type: 'MODULE12_SET_GameDetials', payload: game_detail });
    },
    [dispatch, module12.game_details, module12.rewards]
  );

  const updateProgress = (async () => {
		const payload = {
			body: {
				id: login.studentid,
				module: "UnderstandFeelings",
				day_completed: module12.currentday,
				time_completed: new Date().toDateString(),
			},
		}
		await API.put('TIR', '/v3/student/progress', payload)
		.then((response) => {
		})
		.catch((error) => {
		});
	})

  const updateDB = useCallback(async () => {
    const myInit = {
      body: {
        id: module12.moduleID,
        day_completed: module12.day_completed,
        step_completed: module12.stepCompleted,
        game_details: JSON.stringify(module12.game_details),
      },
    };
    await API.put('TIR', '/v3/student/module', myInit)
      .then((response) => {
        if (displayGreenButton) {
          setAnimalVoice(null);
          setShowAnimal(true);
          setPlayDogCelebrate(true);
          setAnimalState(animalClose);
          setdisplayGreenButton(false);
          setDisplayReward(false);
        }
      })
      .catch(() => {
        if (
          module12.stepCompleted === 'notstarted' ||
          module12.stepCompleted === 'learn' ||
          module12.stepCompleted === 'practice' ||
          module12.stepCompleted === 'celebrate' ||
          module12.stepCompleted === 'followthebeat'
        ) {
          window.alert('Connection is lost. Please login again.');
          dispatch({ type: 'CLEAR' });
          Auth.signOut();
          navigate('/');
        }
      });
      const myInit2 = {
        body: {
          id: login.studentid,
          current_module: 'UnderstandFeelings',
        },
      };
      await API.put('TIR', '/v3/student', myInit2)
      .then((response) => {
      })
      .catch((error) => {
      });
  });

  useEffect(() => {
    getGifs();
  }, [getGifs]);

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
    } else {
      if(login.grade !== "Teacher Mode" && login.grade !== 'Free Play'){
        updateDB();
      }
    }
  }, [module12.stepCompleted]);

    useEffect(() => {
      if((module12.reviewIcon === true || login.grade === "Teacher Mode") && module12.sectionCompleted === 4 ) {
          updateProgress();
          module12.sectionCompleted = 0;
      }
    }, [module12.sectionCompleted])

  useEffect(() => {
    if (module12.coins >= 100) {
      setPrize(true);
    }
    if (coinUpdate.current) {
      coinUpdate.current = false;
    } else {
      createGameDetails(false, false, module12.coins);
      updateDB();
    }
  }, [module12.coins]);

  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (module12.currentday <= module12.day_completed || login.grade === "Teacher Mode" || login.grade === "Free Play") {
      if(login.grade === "Teacher Mode" || login.grade === "Free Play"){
        setShowReward(true)
      }
      dispatch({ type: 'MODULE12_TOGGLE_REVIEW_ICON', payload: true });
      dispatch({ type: 'MODULE12_SET_KEY', payload: 4 });
      if (module12.currentday === 4 || module12.currentday === 8) {
        dispatch({ type: 'MODULE12_SET_KEY', payload: 5 });
      }
    } else {
      if (module12.stepCompleted === checkStep) {
        setCoinIcon(true);
      }
      dispatch({ type: 'MODULE12_TOGGLE_REVIEW_ICON', payload: false });
      if (module12.currentday === 4 && module12.day_completed === 3) {
        if (module12.stepCompleted === 'notstarted') {
          dispatch({ type: 'MODULE12_SET_KEY', payload: 0 });

        } else if (module12.stepCompleted === 'singingtime') {
          dispatch({ type: 'MODULE12_SET_KEY', payload: 1 });

        } else if (module12.stepCompleted === 'learn') {
          dispatch({ type: 'MODULE12_SET_KEY', payload: 2 });

        } else if (module12.stepCompleted === 'practice') {
          dispatch({ type: 'MODULE12_SET_KEY', payload: 3 });

        } else if (module12.stepCompleted === 'followthebeat') {
          dispatch({ type: 'MODULE12_SET_KEY', payload: 4 });
        } else if (module12.stepCompleted === 'celebrate') {
          setKeyIcon(true);
          dispatch({ type: 'MODULE12_SET_KEY', payload: 5 });
        }
        playButtonAudio();
      } else {
        if (module12.stepCompleted === 'notstarted') {
          dispatch({ type: 'MODULE12_SET_KEY', payload: 0 });

        } else if (module12.stepCompleted === 'learn') {
          dispatch({ type: 'MODULE12_SET_KEY', payload: 1 });

        } else if (module12.stepCompleted === 'practice') {
          dispatch({ type: 'MODULE12_SET_KEY', payload: 2 });

        } else if (module12.stepCompleted === 'followthebeat') {
          dispatch({ type: 'MODULE12_SET_KEY', payload: 3 });

        } else if (module12.stepCompleted === 'celebrate') {
          if (module12.currentday === 8 && module12.day_completed === 7) {
            dispatch({ type: 'MODULE12_SET_KEY', payload: 4 });
            setPresentIcon(true);
          } else {
            setKeyIcon(true);
            dispatch({ type: 'MODULE12_SET_KEY', payload: 4 });
          }
        } else if (module12.stepCompleted === 'surprise') {
          dispatch({ type: 'MODULE12_SET_KEY', payload: 5 });
          setKeyIcon(true);
        }
        playButtonAudio();
      }
    }
  }, [module12.stepCompleted]);

  let [displayGreenCheck, setDisplayGreenCheck] = useState(false);
  let [dropZone, setDropZone] = useState(false);

  const selectReward = () => {
    return (
      <>
        <div className='rewards' id ='rewardList'>
          <div className='circle' id='rewardItemLeft2'>
            <img
              src={rewardOption1}
              alt=''
              onClick={() => {
                dispatch({
                  type: `MODULE12_SET_REWARD${module12.currentday}1`,
                  payload: true,
                });
                dispatch({
                  type: `MODULE12_SET_REWARD${module12.currentday}2`,
                  payload: false,
                });
                document.getElementById('rewardItemLeft2').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemRight2').style.borderColor =
                  'white';
                setTouchButton(true);
                setDisplayGreenCheck(true);
              }}
            />
          </div>
          <div className='circle' id='rewardItemRight2'>
            <img
              src={rewardOption2}
              alt=''
              onClick={() => {
                dispatch({
                  type: `MODULE12_SET_REWARD${module12.currentday}2`,
                  payload: true,
                });
                dispatch({
                  type: `MODULE12_SET_REWARD${module12.currentday}1`,
                  payload: false,
                });
                document.getElementById('rewardItemRight2').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemLeft2').style.borderColor =
                  'white';
                setTouchButton(true);
                setDisplayGreenCheck(true);
              }}
            />
          </div>
        </div>
        <div className='greenCheckDiv'>
            {displayGreenCheck && <img className='greenCheck' src={greenCheck} alt="" onClick={() => { 
                document.getElementById("rewardList").style.zIndex = 1;
                setCheckSound(true);
                setDropZone(true);
                setDisplayGreenCheck(false);
                setdisplayGreenButton(true);
            }}/>}
        </div>
        {dropZone && <div class="area">
            <div id="dropZone">Drag and drop your item</div>
        </div>}
        <div className='greenCheckDiv'>
          {displayGreenButton && (
            <img
              className='greenCheck'
              src={greenCheck}
              alt=''
              onClick={() => {
                setCheckSound(true);
                setDropZone(false);
                updateProgress();
                sleep(500).then(() => {
                  createGameDetails(false, true);
                  if(login.grade === "Teacher Mode" || login.grade === "Free Play"){
                    updateDB();
                  }
                  dispatch({
                    type: `MODULE12_SET_DAY_UNLOCK${module12.currentday + 1}`,
                    payload: true,
                  });
                  dispatch({
                    type: 'MODULE12_SET_dayCompleted',
                    payload: module12.currentday === 8 ? 9 : module12.currentday,
                  });
                  dispatch({
                    type: 'MODULE12_SET_stepCompleted',
                    payload: 'notstarted',
                  }); // change this back to notstarted
                });
              }}
            />
          )}
        </div>
      </>
    );
  };

  const openPrize = () => {
    return (
      <>
        <div className='rewards'>
          <div className='circle' id='rewardItemLeft'>
            <img
              src={FaeDragon}
              alt=''
              onClick={() => {
                dispatch({ type: 'MODULE12_SET_PRIZE1', payload: true });
                dispatch({ type: 'MODULE12_SET_PRIZE2', payload: false });
                document.getElementById('rewardItemLeft').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemRight').style.borderColor =
                  'white';
                setTouchButton(true);
                setDisplayGreenCheck(true);
              }}
            />
          </div>
          <div className='circle' id='rewardItemRight'>
            <img
              src={FaeHouse}
              alt=''
              onClick={() => {
                dispatch({ type: 'MODULE12_SET_PRIZE2', payload: true });
                dispatch({ type: 'MODULE12_SET_PRIZE1', payload: false });
                document.getElementById('rewardItemRight').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemLeft').style.borderColor =
                  'white';
                setTouchButton(true);
                setDisplayGreenCheck(true);
              }}
            />
          </div>
        </div>
        <div className='greenCheckDiv'>
            {displayGreenCheck && <img className='greenCheck' src={greenCheck} alt="" onClick={() => { 
                setCheckSound(true);
                setDropZone(true);
                setDisplayGreenCheck(false);
                setdisplayGreenButton(true);
            }}/>}
        </div>
        {dropZone && <div class="area">
            <div id="dropZone">Drag and drop your item</div>
        </div>}
        <div className='greenCheckDiv'>
          {displayGreenButton && (
            <img
              className='greenCheck'
              src={greenCheck}
              alt=''
              onClick={() => {
                setCheckSound(true);
                setDropZone(false);
                setDisplayPrize(false);
                sleep(500).then(() => {
                  setdisplayGreenButton(false);
                  createGameDetails(false, true);
                  dispatch({
                    type: 'MODULE12_SET_COIN',
                    payload: module12.coins - 100,
                  });
                });
              }}
            />
          )}
        </div>
      </>
    );
  };

  useEffect(() => {
    switch (module12.currentday) {
      case 1:
        setRewardOption1(SlideRed);
        setRewardOption2(SlideYellow);
        break;
      case 2:
        setRewardOption1(GnomeBlue);
        setRewardOption2(GnomeGreen);
        break;
      case 3:
        setRewardOption1(SpringToy);
        setRewardOption2(TireSwing);
        break;
      case 4:
        setRewardOption1(FairyGreen);
        setRewardOption2(FairyPurple);
        break;
      case 5:
        setRewardOption1(MonkeybarsBlue);
        setRewardOption2(MonkeybarsYellow);
        break;
      case 6:
        setRewardOption1(FrogCrown);
        setRewardOption2(FrogVelvet);
        break;
      case 7:
        setRewardOption1(KitePink);
        setRewardOption2(KitePurple);
        break;
      case 8:
        setRewardOption1(FlowerPink);
        setRewardOption2(FlowerBlue);
        break;
      default:
        setdisplayGreenButton(true);
        break;
    }
  }, [
    keyIcon,
    FairyGreen,
    FairyPurple,
    FlowerBlue,
    FlowerPink,
    FrogCrown,
    FrogVelvet,
    GnomeBlue,
    GnomeGreen,
    KitePink,
    KitePurple,
    MonkeybarsBlue,
    MonkeybarsYellow,
    SlideRed,
    SlideYellow,
    SpringToy,
    TireSwing,
    module12.currentday,
  ]);

  const displayReview = () => {
    if (module12.currentday === 4) {
      return (
        <>
          <div className='world2reviewContainer'>
            <img
              className='reviewBtns41'
              src={SingingTimeIcon}
              alt='singing button'
              onClick={() => {
                displaySinging();
              }}
            />
            <img
              className='reviewBtns42'
              src={learnBtn}
              alt='learn button'
              onClick={() => {
                openLearn();
              }}
            />
            <img
              className='reviewBtns43'
              src={practiceBtn}
              alt='practice button'
              onClick={() => {
                openPractice();
              }}
            />
            <img
              className='reviewBtns44'
              src={ftbBtn}
              alt='ftb button'
              onClick={() => {
                openFTB();
              }}
            />
            <img
              className='reviewBtns45'
              src={celebrateBtn}
              alt='celebrate button'
              onClick={() => {
                openCelebrate();
              }}
            />
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className='world2reviewContainer'>
            <img
              className='reviewBtns1'
              src={learnBtn}
              alt='learn button'
              onClick={() => {
                openLearn();
              }}
            />
            <img
              className='reviewBtns2'
              src={practiceBtn}
              alt='practice button'
              onClick={() => {
                openPractice();
              }}
            />
            <img
              className='reviewBtns3'
              src={ftbBtn}
              alt='ftb button'
              onClick={() => {
                openFTB();
              }}
            />
            <img
              className='reviewBtns4'
              src={celebrateBtn}
              alt='celebrate button'
              onClick={() => {
                openCelebrate();
              }}
            />
          </div>
        </>
      );
    }
  };

  const introduction = () => {
    return (
      <div>
        <CloudfrontVideoFormat
          source={introVideo}
          back='/understandfeelings/navigation'
          background={background}
          token={login.cookie}
          ended={() => {
            // here is where you can add dispatch functions
            setDisplayIntroVideo(false);
            setDisplayBody(true);
            if (module12.currentday === 4) {
              dispatch({ type: 'MODULE12_SET_KEY', payload: 1 });
              playButtonAudio();
            }
            if (module12.day_completed === 9) {
              navigate('/understandfeelings/navigation');
            }
          }}
        />
      </div>
    );
  };

  const openLearn = async () => {
    let song =  getVideo('appfiles/understand_feelings/understand_feelings_demo.m4a', login);
    let video =  getVideo('appfiles/understand_feelings/learn_video.mp4', login);
    switch (module12.currentday) {
      case 1:
        setLearn(
          <Learn
            video='9da475cb999904511af860fe47bb/480.m3u8'
            songVideo={video}
            closingVideo='606c9b065531f738da7fa93e282e/480.m3u8'
            destiny='/understandfeelings'
            song={song}
            back='/understandfeelings'
            background={background}
            setDisplayLearn={setDisplayLearn}
            step_completed='MODULE12_SET_stepCompleted'
            module={module12}
          />
        );
        break;
      case 2:
        setLearn(
          <Learn
            video='87807c7902d3919220b7c0c7f905/480.m3u8'
            songVideo={video}
            closingVideo='8d7c4ecf7fbb9c63849fc97f915f/480.m3u8'
            destiny='/understandfeelings'
            song={song}
            back='/understandfeelings'
            background={background}
            setDisplayLearn={setDisplayLearn}
            step_completed='MODULE12_SET_stepCompleted'
            module={module12}
          />
        );
        break;
      case 3:
        setLearn(
          <Learn
            video='6270ac19a130999f3fc659a705bd/480.m3u8'
            songVideo={video}
            closingVideo='4f71961a6a1183ccf95ce4425df3/480.m3u8'
            destiny='/understandfeelings'
            song={song}
            back='/understandfeelings'
            background={background}
            setDisplayLearn={setDisplayLearn}
            step_completed='MODULE12_SET_stepCompleted'
            module={module12}
          />
        );
        break;
      default:
        // setShowAnimal(true);
        // setAnimalState(learnIntro);
        // setAnimalVoice(getVideo('appfiles/understand_feelings/understand_feelings_learn_intro.mp3', login));
        // setDisplayVoice(true)
        await GetUserVideo(`userfiles/${module12.StudentID}/understand_feelings_play_day_music.m4a`).then((data) => {
          fetch(data).then((response) => {
            GetUserVideo(`influencers/${influencers[module12.currentday - 4]}/answer_affirmation.mp4`).then((influencerVideo) => {
              if (response.status === 200) {
                setLearn(
                  <Learn
                    songVideo={video}
                    destiny='/understandfeelings'
                    song={data}
                    back='/understandfeelings'
                    background={background}
                    setDisplayLearn={setDisplayLearn}
                    step_completed='MODULE12_SET_stepCompleted'
                    module={module12}
                    instrumental={getVideo('appfiles/understand_feelings/understand_feelings_sing_along.m4a', login)}
                    influencerVideo={influencerVideo}
                  />
                );
              } else {
                setLearn(
                  <Learn
                    songVideo={video}
                    destiny='/understandfeelings'
                    song={song}
                    back='/understandfeelings'
                    background={background}
                    setDisplayLearn={setDisplayLearn}
                    step_completed='MODULE12_SET_stepCompleted'
                    module={module12}
                    influencerVideo={influencerVideo}
                  />
                );
              }
            });
          });
        });
        break;
    }
    setDisplayLearn(true);
  };

  const openPractice = async () => {
    setDisplayPractice(true);
  };

  const openFTB = async () => {
    // switch (module12.currentday) {
    //   case 1:
    //     break;
    //   case 2:
    //     break;
    //   case 3:
    //     break;

    //   default:
    //     setShowAnimal(true);
    //     setAnimalState(followTheBeatIntro);
    //     setAnimalVoice(getVideo('appfiles/answer/answer_ftb_intro.mp3', login));
    //     break;
    //     // setDisplayVoice(true)
    // }
    setDisplayFTB(true);
  };

  const openCelebrate = async () => {
    const celebrateVideo1 = '4a642a866fb4ff2b54e9c7c024a4/480.m3u8';
    const celebrateVideo2 = 'ca5f564d9daff7adbc2cb0d8bfbf/480.m3u8';
    const celebrateVideo3 = 'a947c274cfd75b2aaf55b4782815/480.m3u8';

    switch (module12.currentday) {
      case 1:
        setCelebrate(
          <Celebrate
            module={module12}
            celebrateVideo={celebrateVideo1}
            background={background}
            setDisplayCelebrate={setDisplayCelebrate}
            moduleNum={'MODULE12'}
          />
        );
        break;
      case 2:
        setCelebrate(
          <Celebrate
            module={module12}
            celebrateVideo={celebrateVideo2}
            background={background}
            setDisplayCelebrate={setDisplayCelebrate}
            moduleNum={'MODULE12'}
          />
        );
        break;
      case 3:
        setCelebrate(
          <Celebrate
            module={module12}
            celebrateVideo={celebrateVideo3}
            background={background}
            setDisplayCelebrate={setDisplayCelebrate}
            moduleNum={'MODULE12'}
          />
        );
        break;
      default:
        // setShowAnimal(true);
        // setAnimalVoice(getVideo('appfiles/answer/answer_celebrate_intro.mp3', login));
        // // setDisplayVoice(true)
        // setAnimalState(celebrateIntro);
        let voice1 = getVideo('appfiles/answer/answer_celebrate_record_amazing.mp3', login);
        let voice2 = getVideo('appfiles/answer/answer_celebrate_say_thanks.mp3', login);
        let voice3 = getVideo('appfiles/answer/answer_amazing_job.mp3', login);
        let animalGIF = getVideo('appfiles/understand_feelings/understand_feelings_joyful.gif', login);
        let animalVoice = getVideo('appfiles/understand_feelings/understand_feelings_joyful_jingle_intro.mp3', login);
        await GetUserVideo(`influencers/${influencers[module12.currentday - 4]}/answer_affirmation.mp4`).then((influencerVideo) => {
          setCelebrate(
            <Celebrate
              world3={true}
              module={module12}
              background={background}
              voice1={voice1}
              voice2={voice2}
              voice3={voice3}
              animalGIF={animalGIF}
              animalVoice={animalVoice}
              text={
                'Record yourself in an excited voice and say, "I am amazing!"'
              }
              name={`understand_feelings_celebration_surprise_${
                module12.currentday + 1
              }.mp4`}
              influencerVideo={influencerVideo}
              animation={amazingJobDog}
              animal={animal}
              setDisplayCelebrate={setDisplayCelebrate}
              moduleNum={'MODULE12'}
            />
          );
        })
        break;
    }
    setDisplayCelebrate(true);
  };

  const displaySinging = async () => {
    const introVideo = 'ae95c670e92a45c950c68a33b2f1/480.m3u8';
    let noteVideo = getVideo('appfiles/understand_feelings/understand_feelings_student_notes.mp4', login);
    let singingMusic = getVideo('appfiles/understand_feelings/understand_feelings_sing_along.m4a', login);
    let domeMusic = getVideo('appfiles/understand_feelings/understand_feelings_demo.m4a', login);
    let instrumental = getVideo('appfiles/understand_feelings/understand_feelings_instrumental.m4a', login);
    setSingTime(
      <SingingTime
        introVideo={introVideo}
        demoMusic={domeMusic}
        singingVideo={noteVideo}
        background={background}
        singingMusic={singingMusic}
        setDisplaySingingTime={setDisplaySingingTime}
        module={module12}
        moduleNum='MODULE12'
        name='understand_feelings'
        instrumental={instrumental}
        instrumentalURL={'appfiles/understand_feelings/understand_feelings_sing_along.m4a'}
      />
    );
    setDisplaySingingTime(true);
  };

  const getSurprise = async () => {
    const usePhoto = [
      {
        video: `influencers/${login.influencerid}/answer_affirmation.mp4`,
      },
      {
        video: `userfiles/${module12.StudentID}/understand_feelings_celebration_surprise_5.mp4`,
      },
      {
        video: `influencers/${login.influencerid1}/answer_affirmation.mp4`,
      },
      {
        video: `userfiles/${module12.StudentID}/understand_feelings_celebration_surprise_7.mp4`,
      },
      {
        video: `influencers/${login.influencerid2}/answer_video_message.mp4`,
      },
      {
        video: `influencers/${login.influencerid3}/answer_affirmation.mp4`,
      },
      {
        video: `userfiles/${module12.StudentID}/understand_feelings_celebration_surprise_9.mp4`,
      },
      {
        video: `influencers/${login.influencerid4}/answer_affirmation.mp4`,
      },
    ];

    for (let i = 0; i < usePhoto.length; i++) {
      await GetUserVideo(usePhoto[i].video, login).then((data) => {
        usePhoto[i].video = data;
      });
    }
    
    return usePhoto;
  };

  const playSurpriseVideo = async () => {
    await getSurprise().then((photo) => {
      setSurpriseVideo(
        <Surprise
          background={background}
          music={getVideo('appfiles/understand_feelings/understand_feelings_instrumental.m4a', login)}
          animal={animal}
          back={'/'}
          slides={photo}
          setDisplaySurprise={setDisplaySurprise}
        />
      );
    });
    setDisplaySurprise(true);
    setKeyIcon(true);
    setPresentIcon(false);
  };

  const keyAnimation = () => {
    setRewardAnimationState('fade-out');
    sleep(1000).then(() => {
      diggingAnimation();
    });
  };

  const diggingAnimation = () => {
    setPlayDigging(true);
  };

  const closeDay8Video = () => {
    setDisplayIntroVideo(true);
    setDisplayBody(false);
    setShowAnimal(false);
    setIntroVideo(AfterCelebrateVideo9);
  };

  const onStop = (reward, data) => {
    const position = { x: data.x / clientWidth, y: data.y / clientHeight };

    if (reward === 1 || reward === 2) {
      dispatch({
        type: `MODULE12_SET_PRIZE${reward}_POSITION`,
        payload: position,
      });
    } else {
      dispatch({
        type: `MODULE12_SET_REWARD${reward}_POSITION`,
        payload: position,
      });
    }
  };

  return (
    <>
      {playDogCelebrate && (
        <audio
          autoPlay
          onPlay={() => {
            setAudioReady(true);
          }}
          onEnded={() => {
            setPlayDogCelebrate(false);
            module12.currentday === 8
              ? closeDay8Video()
              : navigate('/understandfeelings/navigation');
          }}
        >
          <source src={animalCloseAudio} type='audio/mp3' />
        </audio>
      )}
      {playDiggingAudio && (
        <audio
          autoPlay
          onPlay={() => {
            setDirtState(true);
            setAudioReady(true);
          }}
          onEnded={() => {
            setAudioReady(false);
            setPlayDigging(false);
            setDirtState(false);
            setPlayDiggingAudio(false);
            setKeyIcon(false);
            setDisplayReward(true);
            setRewardsFound(true);
          }}
        >
          <source
            src={
              generateImageUrl('media/Module2Videos/dog_digging.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {coinAudio && (
        <audio
          autoPlay
          onEnded={() => {
            dispatch({
              type: 'MODULE12_SET_COIN',
              payload: module12.coins + 1,
            });
            setCoinAudio(false);
            setCoinAnimationState('bounceIcons');
            setCoinIcon(false);
            playButtonAudio();
          }}
        >
          <source
            src={
              generateImageUrl('media/Module5Videos/earn_token.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {checkSound && (
        <audio
          autoPlay
          onEnded={() => {
            setCheckSound(false);
          }}
        >
          <source
            src={
              generateImageUrl('media/Module1Videos/button_accept_item.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {rewardsFound && (
        <audio autoPlay>
          <source
            src={
              generateImageUrl('media/Module2Videos/daily_rewards_present.mp3')
            }
          ></source>
        </audio>
      )}
      {touchButton && (
        <audio
          autoPlay
          onEnded={() => {
            setTouchButton(false);
          }}
        >
          <source
            src={
              generateImageUrl('media/Module1Videos/touch_button.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {buttonSound && (
        <audio
          autoPlay
          onEnded={() => {
            setButtonSound(false);
          }}
        >
          <source
            src={
              generateImageUrl('media/Module1Videos/button_bouncing.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}

      {displayVoice && (
        <audio
          autoPlay
          onPlay={() => {
            setAudioReady(true);
          }}
          onEnded={() => {
            setAudioReady(false);
            setDisplayVoice(false);
            setShowAnimal(false);
          }}
        >
          <source src={animalVoice}></source>
        </audio>
      )}

      {displayIntroVideo && introduction()}
      {!showAnimal && displayLearn && learn}
      {displayPractice && (
        <Practice
          setDisplayPractice={setDisplayPractice}
          background={background2}
          stepComplete={'MODULE12_SET_stepCompleted'}
          module={module12}
          practiceConversation={answerWatch}
          specialMessage={answerSpecialMessage}
          awesomeJob={amazingJobDog}
        />
      )}
      {!showAnimal && displayFTB && (
        <FollowTheBeatModule7
          unit3={true}
          setDisplayFTB={setDisplayFTB}
          awesomeJob={amazingJobDog}
          instruction={ftbInstruction}
          instructionGIF={ftbInstructionGIF}
          song={ftbMusic}
          count={ftbCount}
          tutorial1={ftbTutorial1}
          tutorial2={ftbTutorial2}
          walkthrough={ftbWT}
          stepComplete={'MODULE12_SET_stepCompleted'} 
          module={module12}
          score={'ftb_understand_feelings'}
        />
      )}
      {displaySingingTime && singTime}
      {!showAnimal && displayCelebrate && celebrate}
      {displaySurprise && surpriseVideo}
      {((displaybody &&
        !displayLearn &&
        !displayPractice &&
        !displaySingingTime &&
        !displayCelebrate &&
        !displaySurprise &&
        !displayFTB &&
        !displayDay4Practice) ||
        showAnimal) && (
        <div
          className='understandfeelingsWorldBody'
          style={{ backgroundImage: `url(${background})` }}
        >
          <div className='navigation'>
            <img
              className='logoutBtn'
              src={logoutBtn}
              alt='Logout Button'
              onClick={togglePopup}
            />
            <img
              className='JourneyBlueImage'
              src={journeyImage}
              alt='Navigation blue world'
              onClick={() => {
                navigate('/understandfeelings/navigation');
              }}
            />
          </div>
          {isOpen && (
            <PopUp
              content={
                <>
                  <b id='title'>
                    Are you sure you want to leave?
                    <br />
                  </b>
                  <button
                    id='logoutButton1'
                    className='logoutButton'
                    onClick={() => {
                      navigate('/');
                      userHasAuthenticated(false);
                      localStorage.setItem('token', 'false');
                    }}
                  >
                    YES
                  </button>
                  <button
                    id='logoutButton2'
                    className='logoutButton'
                    onClick={togglePopup}
                  >
                    NO
                  </button>
                </>
              }
              handleClose={togglePopup}
            />
          )}

          {prize && (
            <audio autoPlay>
              <source src={presentSound}></source>
            </audio>
          )}

          {prize && (
            <img
              className='prize'
              src={
                generateImageUrl('images/Images/prize.png')
              }
              alt='Logout Button'
              onClick={() => {
                setPrize(false);
                setDisplayPrize(true);
              }}
            />
          )}
          {prize && (
            <button
              className='prize-button'
              onClick={() => {
                setPrize(false);
                setDisplayPrize(true);
              }}
            >
              {' '}
              <h5>Click Here</h5>
            </button>
          )}
          {disPlayPrize && openPrize()}

          <img className='dogGif' src={dogState} alt='dog Icon' />
          {showAnimal && !audioReady && (
            <img alt='' id='loading' src={loading} />
          )}
          {showAnimal && (
            <img
              alt=''
              style={audioReady ? {} : { display: 'none' }}
              src={animalState}
              className='dogGif'
              onLoad={() => setDisplayVoice(true)}
              onError={() => setShowAnimal(false)}
            />
          )}
          {playDigging && (
            <img
              alt=''
              style={audioReady ? {} : { display: 'none' }}
              src={dogDig}
              className='dogGif'
              onLoad={() => setPlayDiggingAudio(true)}
            />
          )}
          {dirtState && (
            <img
              className='dirt'
              src={dirtCloud}
              alt=''
              id='dirtAnimation'
              style={{
                position: 'absolute',
                zIndex: 2,
                top: '70%',
                left: '50%',
                height: '120px',
                width: '140px',
                marginTop: '90px',
                marginLeft: '-70px',
              }}
            ></img>
          )}

          <div className='scoreBar'>
            <img
              className='scoreKey'
              src={coinBar}
              alt='crab Icon'
              
            />
            {module12.coins < 10 && (
              <h5 className='scoretext1'>{module12.coins}</h5>
            )}
            {module12.coins >= 10 && module12.coins < 100 && (
              <h5 className='scoretext10'>{module12.coins}</h5>
            )}
            {module12.coins >= 100 && (
              <h5 className='scoretext100'>{module12.coins}</h5>
            )}
            <p className='scoretext'>100</p>
          </div>

          {module12.currentday === 4 || module12.currentday === 8 ? (
            <div className='progressBar3'>
              <img
                className='progressKey3'
                src={keys5[module12.keys]}
                alt='crab Icon'
                
              />
              <h3 className='progresstext3'>{module12.keys}/5</h3>
            </div>
          ) : (
            <div className='progressBar3'>
              <img
                className='progressKey3'
                src={keys4[module12.keys]}
                alt='crab Icon'
                
              />
              <h3 className='progresstext3'>{module12.keys}/4</h3>
            </div>
          )}

          {!showAnimal &&
            !module12.reviewIcon &&
            !coinIcon &&
            !disPlayPrize && 
            !dropZone && (
              <div className='actionBtnDiv'>
                {module12.currentday === 4 &&
                  module12.stepCompleted === 'notstarted' && (
                    <img
                      className='actionBtn2'
                      id='bounceIcons'
                      src={SingingTimeIcon}
                      alt='learn button'
                      onClick={() => {
                        setTouchButton(true);
                        sleep(500).then(() => {
                          displaySinging();
                          setCheckStep('singingtime');
                        });
                      }}
                    />
                  )}
                {module12.currentday !== 4 &&
                  module12.stepCompleted === 'notstarted' && (
                    <img
                      className='actionBtn2'
                      id='bounceIcons'
                      src={learnBtn}
                      alt='learn button'
                      onClick={() => {
                        setTouchButton(true);
                        sleep(500).then(() => {
                          openLearn();
                          setCheckStep('learn');
                        });
                      }}
                    />
                  )}

                {module12.stepCompleted === 'learn' && (
                  <img
                    className='actionBtn2'
                    id='bounceIcons'
                    src={practiceBtn}
                    alt='practice button'
                    onClick={() => {
                      touchSound.play()
                      sleep(500).then(() => {
                        openPractice();
                        setCheckStep('practice');
                      });
                    }}
                  />
                )}
                {module12.stepCompleted === 'practice' && (
                  <img
                    className='actionBtn2'
                    id='bounceIcons'
                    src={ftbBtn}
                    alt='celebrate button'
                    onClick={() => {
                      setTouchButton(true);
                      sleep(500).then(() => {
                        openFTB();
                        setCheckStep('followthebeat');
                      });
                    }}
                  />
                )}
                {module12.stepCompleted === 'followthebeat' && (
                  <img
                    className='actionBtn2'
                    id='bounceIcons'
                    src={celebrateBtn}
                    alt='celebrate button'
                    onClick={() => {
                      setTouchButton(true);
                      sleep(500).then(() => {
                        openCelebrate();
                        setCheckStep('celebrate');
                      });
                    }}
                  />
                )}
                {module12.stepCompleted === 'singingtime' && (
                  <img
                    className='actionBtn2'
                    id='bounceIcons'
                    src={learnBtn}
                    alt='singing button'
                    onClick={() => {
                      setTouchButton(true);
                      sleep(500).then(() => {
                        openLearn();
                        setCheckStep('learn');
                      });
                    }}
                  />
                )}
              </div>
            )}

          {!displayVoice && coinIcon && !disPlayPrize && (
            <div className='actionBtnDiv'>
              {!module12.reviewIcon && (
                <img
                  className='chooseReward'
                  id={coinAnimationState}
                  src={coin}
                  alt='reward key'
                  style={{
                    position: 'absolute',
                    top: '50vh',
                    left: '50vw',
                    width: '100px',
                    height: '100px',
                    marginLeft: '-50px',
                    marginTop: '-50px',
                    zIndex:10,
                  }}
                  onClick={() => {
                    coinAnimation();
                  }}
                />
              )}
            </div>
          )}

          {!disPlayPrize &&
            !showAnimal &&
            !displayReward &&
            module12.reviewIcon && (
              <div className='actionBtnDiv'>
                {module12.reviewIcon && (
                <img
                  className={showReward ? 'actionBtn3' : 'actionBtn2'}
                  src={reviewBtn}
                  alt='review button'
                  onClick={() => {
                    setTouchButton(true);
                    sleep(500).then(() => {
                      setReviewIcon(!reviewIcon);
                    });
                  }}
                  />)}
                  {showReward && (
                    <img
                      src={rewardBtn}
                      className='actionBtn4'
                      alt='review button'
                      onClick={() => {
                        setTouchButton(true);
                        sleep(500).then(() => {
                          keyAnimation();
                        });
                      }}
                  />)}
                {module12.reviewIcon && reviewIcon && displayReview()}
              </div>
            )}

          {keyIcon && !coinIcon && !disPlayPrize && (
            <img
              className='rewardsIcon'
              style={{
                width: '150px',
                height: '50px',
                marginLeft: '-75px',
                zIndex: 10,
              }}
              id={rewardAnimationState}
              src={keyReward}
              alt='reward bone'
              onClick={() => {
                keyAnimation();
              }}
            />
          )}
          {displayReward && selectReward()}

          {!disPlayPrize && !coinIcon && presentIcon && (
            <img
              className='present'
              style={{
                width: '84px',
                height: '100px',
                marginLeft: '-42px',
                zIndex: 10,
              }}
              id='bounceIcons'
              src={present}
              alt='gift'
              onClick={() => {
                playSurpriseVideo();
              }}
            />
          )}
          {!disPlayPrize && !coinIcon && presentIcon && (
            <audio autoPlay>
              <source src={presentSound}></source>
            </audio>
          )}

          <div className='rewardArea'>
            {module12.rewards.SlideRed.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module12.rewards.SlideRed.x * clientWidth,
                  y: module12.rewards.SlideRed.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(11, data);
                }}
              >
                <div
                  className='moveSlide1'
                  style={{ backgroundImage: `url(${SlideRed})` }}
                ></div>
              </Draggable>
            )}

            {module12.rewards.SlideYellow.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module12.rewards.SlideYellow.x * clientWidth,
                  y: module12.rewards.SlideYellow.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(12, data);
                }}
              >
                <div
                  className='moveSlide2'
                  style={{ backgroundImage: `url(${SlideYellow})` }}
                ></div>
              </Draggable>
            )}

            {module12.rewards.GnomeBlue.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module12.rewards.GnomeBlue.x * clientWidth,
                  y: module12.rewards.GnomeBlue.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(21, data);
                }}
              >
                <div
                  className='moveSmallReward1'
                  style={{ backgroundImage: `url(${GnomeBlue})` }}
                ></div>
              </Draggable>
            )}

            {module12.rewards.GnomeGreen.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module12.rewards.GnomeGreen.x * clientWidth,
                  y: module12.rewards.GnomeGreen.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(22, data);
                }}
              >
                <div
                  className='moveSmallReward2'
                  style={{ backgroundImage: `url(${GnomeGreen})` }}
                ></div>
              </Draggable>
            )}

            {module12.rewards.SpringToy.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module12.rewards.SpringToy.x * clientWidth,
                  y: module12.rewards.SpringToy.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(31, data);
                }}
              >
                <div
                  className='moveReward1'
                  style={{ backgroundImage: `url(${SpringToy})` }}
                ></div>
              </Draggable>
            )}

            {module12.rewards.TireSwing.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module12.rewards.TireSwing.x * clientWidth,
                  y: module12.rewards.TireSwing.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(32, data);
                }}
              >
                <div
                  className='moveTire2'
                  style={{ backgroundImage: `url(${TireSwing})` }}
                ></div>
              </Draggable>
            )}

            {module12.rewards.FairyGreen.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module12.rewards.FairyGreen.x * clientWidth,
                  y: module12.rewards.FairyGreen.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(41, data);
                }}
              >
                <div
                  className='moveClam1'
                  style={{ backgroundImage: `url(${FairyGreen})` }}
                ></div>
              </Draggable>
            )}

            {module12.rewards.FairyPurple.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module12.rewards.FairyPurple.x * clientWidth,
                  y: module12.rewards.FairyPurple.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(42, data);
                }}
              >
                <div
                  className='moveClam2'
                  style={{ backgroundImage: `url(${FairyPurple})` }}
                ></div>
              </Draggable>
            )}

            {module12.rewards.MonkeybarsBlue.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module12.rewards.MonkeybarsBlue.x * clientWidth,
                  y: module12.rewards.MonkeybarsBlue.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(51, data);
                }}
              >
                <div
                  className='moveSurfBoard1'
                  style={{ backgroundImage: `url(${MonkeybarsBlue})` }}
                ></div>
              </Draggable>
            )}

            {module12.rewards.MonkeybarsYellow.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module12.rewards.MonkeybarsYellow.x * clientWidth,
                  y: module12.rewards.MonkeybarsYellow.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(52, data);
                }}
              >
                <div
                  className='moveSurfBoard2'
                  style={{ backgroundImage: `url(${MonkeybarsYellow})` }}
                ></div>
              </Draggable>
            )}

            {module12.rewards.FrogCrown.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module12.rewards.FrogCrown.x * clientWidth,
                  y: module12.rewards.FrogCrown.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(61, data);
                }}
              >
                <div
                  className='moveClam1'
                  style={{ backgroundImage: `url(${FrogCrown})` }}
                ></div>
              </Draggable>
            )}

            {module12.rewards.FrogVelvet.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module12.rewards.FrogVelvet.x * clientWidth,
                  y: module12.rewards.FrogVelvet.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(62, data);
                }}
              >
                <div
                  className='moveClam2'
                  style={{ backgroundImage: `url(${FrogVelvet})` }}
                ></div>
              </Draggable>
            )}

            {module12.rewards.KitePink.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module12.rewards.KitePink.x * clientWidth,
                  y: module12.rewards.KitePink.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(71, data);
                }}
              >
                <div
                  className='moveReward1'
                  style={{ backgroundImage: `url(${KitePink})` }}
                ></div>
              </Draggable>
            )}

            {module12.rewards.KitePurple.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module12.rewards.KitePurple.x * clientWidth,
                  y: module12.rewards.KitePurple.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(72, data);
                }}
              >
                <div
                  className='moveReward2'
                  style={{ backgroundImage: `url(${KitePurple})` }}
                ></div>
              </Draggable>
            )}

            {module12.rewards.FlowerPink.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module12.rewards.FlowerPink.x * clientWidth,
                  y: module12.rewards.FlowerPink.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(81, data);
                }}
              >
                <div
                  className='moveReward1'
                  style={{ backgroundImage: `url(${FlowerPink})` }}
                ></div>
              </Draggable>
            )}

            {module12.rewards.FlowerBlue.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module12.rewards.FlowerBlue.x * clientWidth,
                  y: module12.rewards.FlowerBlue.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(82, data);
                }}
              >
                <div
                  className='moveReward2'
                  style={{ backgroundImage: `url(${FlowerBlue})` }}
                ></div>
              </Draggable>
            )}

            {module12.rewards.FaeDragon.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module12.rewards.FaeDragon.x * clientWidth,
                  y: module12.rewards.FaeDragon.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(1, data);
                }}
              >
                <div
                  className='movePrize12'
                  style={{ backgroundImage: `url(${FaeDragon})` }}
                ></div>
              </Draggable>
            )}

            {module12.rewards.FaeHouse.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module12.rewards.FaeHouse.x * clientWidth,
                  y: module12.rewards.FaeHouse.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(2, data);
                }}
              >
                <div
                  className='movePrize22'
                  style={{ backgroundImage: `url(${FaeHouse})` }}
                ></div>
              </Draggable>
            )}
          </div>
        </div>
      )}
    </>
  );
};
export default Module12World;
